var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dg-panel"},[(_vm.header)?_c('div',{staticClass:"dg-panel-header"},[_c('h4',[_vm._v(_vm._s(_vm.header))])]):(_vm.hasHeaderSlot)?_c('div',{staticClass:"dg-panel-header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"dg-panel-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }